import { type CSSProperties, type FunctionComponent } from "react";

import trainers from "./assets/trenerzy.webp";

/** Dół wycinka rozpuszczamy maską — ten sam zabieg co w hero na /metamorfoza2026. */
const PHOTO_FADE: CSSProperties = {
  maskImage: "linear-gradient(to bottom, #000 62%, transparent 98%)",
  WebkitMaskImage: "linear-gradient(to bottom, #000 62%, transparent 98%)",
};

/**
 * Photo panel of the sign-in screen: the two trainers cut-out used on the sales landings (a copy of
 * `apps/ecommerce/public/assets/form/trenerzy_1.webp`, transparent background) centred on a dark
 * panel with a soft gold glow behind it and a fade at the bottom.
 */
export const AuthGallery: FunctionComponent = () => {
  return (
    <div className="relative hidden w-0 flex-1 flex-col items-center justify-center overflow-hidden bg-neutral-950 px-10 lg:flex">
      <div
        aria-hidden
        className="absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_45%,rgba(185,168,141,0.38)_0%,rgba(185,168,141,0.1)_55%,transparent_100%)]"
      />
      <img
        src={trainers}
        alt="Trenerzy Programu Hollywood"
        className="relative max-h-[72vh] w-full max-w-[620px] object-contain drop-shadow-[0_30px_50px_rgba(0,0,0,0.65)]"
        style={PHOTO_FADE}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t from-neutral-950 via-neutral-950/70 to-transparent"
      />
      <p className="relative mt-6 text-center text-sm tracking-wide text-white/75">
        18 000+ metamorfoz · 1500 aktywnych klientek · 30+ specjalistów
      </p>
    </div>
  );
};
